import React, { PropsWithChildren, useEffect } from 'react';
import * as S from './styles';
import { Overlay } from '@/components/atoms/Overlay';
import { usePageScrollAreaHook } from '@/components/organisms/PageScrollArea/hook/usePageScrollAreaHook';
import { ROUTE_TO_BREAKPOINT } from '@/hooks/useBreakpoint';

export type MenuLateralTemplateProps = PropsWithChildren<{
  $estaAberto: boolean;
  $alturaToolBar: number;
  onClick?: React.MouseEventHandler<HTMLDivElement | HTMLAnchorElement>;
}>;

export default function MenuLateralTemplate(props: MenuLateralTemplateProps) {
  const { $alturaToolBar, onClick, $estaAberto, children } = props;
  const propsContainer = { $alturaToolBar, $estaAberto };

  const { retornarValorMargemTopo } = usePageScrollAreaHook({
    isPageScrollArea: false,
  });

  const lidarCliqueMenu: React.MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation();
  };

  const desabilitarScroll = () => {
    document.body.style.overflow = 'hidden';

    document.body.addEventListener('touchmove', preventDefault, {
      passive: false,
    });
    document.body.addEventListener('wheel', preventDefault, { passive: false });
  };

  const ativarScroll = () => {
    document.body.style.overflow = 'auto';

    document.body.removeEventListener('touchmove', preventDefault);
    document.body.removeEventListener('wheel', preventDefault);
  };

  const preventDefault = (e: WheelEvent | TouchEvent) => {
    e.preventDefault();
  };

  useEffect(() => {
    if ($estaAberto) {
      desabilitarScroll();
    } else {
      ativarScroll();
    }
    return () => ativarScroll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [$estaAberto]);

  return (
    <React.Fragment>
      <S.Container onClick={lidarCliqueMenu} {...propsContainer}>
        {children}
      </S.Container>
      <Overlay
        onClick={onClick}
        $distanciaTopo={retornarValorMargemTopo('home')}
        $valorSobreposicaoDosDemaisComponentes={995}
        $cssAdicional={`
          visibility: ${$estaAberto ? 'visible' : 'hidden'};
          opacity: ${$estaAberto ? 1 : 0};
          cursor: ${$estaAberto ? 'pointer' : 'none'};
          overflow: hidden;
          @media (min-width: ${ROUTE_TO_BREAKPOINT['/']}px) {
            display: none;
          }
        `}
      />
    </React.Fragment>
  );
}
